import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys } from "./query-keys";

export function useArchiveCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data, error } = await apiClient.POST("/v1/campaigns/{id}/archive", {
        params: { path: { id } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, id) => {
      void qc.invalidateQueries({ queryKey: promotionKeys.campaign(id) });
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
